import { CONFIG } from 'constants';

// ------------------------------------
// Reducer
// ------------------------------------

export default function modalReducer(state = {}, action) {
  return action.type === CONFIG.SUCCESS ? action.payload : state;
}
